import React from 'react';
import classNames from 'classnames';

interface IHeaderAuthorProps {
  dynamicStyle: any;
  styles: any;
  children: string;
}

function HeaderAuthor({ dynamicStyle, styles, children }: IHeaderAuthorProps) {
  return (
    <div
      data-hook="main.header.author"
      className={classNames(styles.headerHost, dynamicStyle.headerHost)}
    >
      {children}
    </div>
  );
}

export default HeaderAuthor;
